(()=>{
  const seen=new WeakSet();
  const near=('IntersectionObserver' in window)?new IntersectionObserver(entries=>{
    for(const e of entries){if(!e.isIntersecting)continue;near.unobserve(e.target);
      const second=e.target.querySelectorAll('.sesh-gallery__frame img')[1];
      if(second){second.loading='eager';second.decode?.().catch(()=>{});}
    }
  },{rootMargin:'750px 0px'}):null;
  const setup=gallery=>{
    if(seen.has(gallery))return;seen.add(gallery);
    const track=gallery.querySelector('[data-gallery-track]');if(!track)return;
    const frames=[...track.querySelectorAll('.sesh-gallery__frame')];if(frames.length<2)return;
    const dots=[...gallery.querySelectorAll('[data-gallery-index]')];
    let active=0,startX=null,startY=null,suppressClickUntil=0,raf=0,holdTimer=null,holding=false;
    const mark=index=>{active=Math.max(0,Math.min(frames.length-1,index));
      dots.forEach((dot,i)=>{const selected=i===active;dot.classList.toggle('is-active',selected);dot.setAttribute('aria-current',selected?'true':'false')});
      frames.forEach((frame,i)=>{frame.tabIndex=i===active?0:-1});
    };
    const go=(index,behavior='smooth')=>{const next=Math.max(0,Math.min(frames.length-1,index));
      track.scrollTo({left:next*track.clientWidth,behavior});mark(next);
    };
    gallery.querySelector('[data-gallery-prev]')?.addEventListener('click',e=>{e.preventDefault();e.stopPropagation();go(active-1)});
    gallery.querySelector('[data-gallery-next]')?.addEventListener('click',e=>{e.preventDefault();e.stopPropagation();go(active+1)});
    dots.forEach(dot=>dot.addEventListener('click',e=>{e.preventDefault();e.stopPropagation();go(Number(dot.dataset.galleryIndex))}));
    gallery.addEventListener('pointerenter',e=>{if(e.pointerType!=='mouse')return;
      const second=frames[1].querySelector('img');if(second)second.loading='eager';go(1,'instant');
    });
    gallery.addEventListener('pointerleave',e=>{if(e.pointerType==='mouse')go(0,'instant')});
    track.addEventListener('scroll',()=>{if(raf)return;raf=requestAnimationFrame(()=>{raf=0;mark(Math.round(track.scrollLeft/Math.max(1,track.clientWidth)))})},{passive:true});
    track.addEventListener('touchstart',e=>{
      if(e.touches.length!==1)return;
      startX=e.touches[0].clientX;startY=e.touches[0].clientY;holding=false;
      clearTimeout(holdTimer);
      holdTimer=setTimeout(()=>{if(startX!==null){holding=true;go(1,'instant')}},180);
    },{passive:true});
    track.addEventListener('touchmove',e=>{
      if(startX===null||e.touches.length!==1)return;
      const dx=e.touches[0].clientX-startX,dy=e.touches[0].clientY-startY;
      if(Math.abs(dx)>7||Math.abs(dy)>7)clearTimeout(holdTimer);
    },{passive:true});
    track.addEventListener('touchend',e=>{
      clearTimeout(holdTimer);
      if(startX===null||!e.changedTouches.length)return;
      const dx=e.changedTouches[0].clientX-startX,dy=e.changedTouches[0].clientY-startY;
      if(holding||(Math.abs(dx)>10&&Math.abs(dx)>Math.abs(dy)))suppressClickUntil=Date.now()+650;
      startX=null;startY=null;
    },{passive:true});
    track.addEventListener('touchcancel',()=>{clearTimeout(holdTimer);startX=null;startY=null},{passive:true});
    track.addEventListener('click',e=>{if(Date.now()<suppressClickUntil){e.preventDefault();e.stopImmediatePropagation();suppressClickUntil=0}},true);
    near?.observe(gallery);mark(0);
  };
  const standard=item=>{if(seen.has(item))return;seen.add(item);
    const slider=item.querySelector('.product-item__image css-slider');if(!slider)return;
    const go=i=>{if(slider.sliderEnabled&&slider.length>1)slider.changeSlide(i,'instant')};
    item.addEventListener('pointerenter',e=>{if(e.pointerType==='mouse')go(1)});
    item.addEventListener('pointerleave',e=>{if(e.pointerType==='mouse')go(0)});
  };
  const scan=root=>{if(root.matches?.('[data-sesh-gallery]'))setup(root);
    root.querySelectorAll?.('[data-sesh-gallery]').forEach(setup);
    if(root.matches?.('.product-item'))standard(root);root.querySelectorAll?.('.product-item').forEach(standard);
  };
  const start=()=>{scan(document);document.addEventListener('shopify:section:load',e=>scan(e.target));
    const observer=new MutationObserver(records=>records.forEach(record=>record.addedNodes.forEach(node=>{if(node.nodeType===1)scan(node)})));
    observer.observe(document.body,{childList:true,subtree:true});
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
})();